<template>
    <div class="row mb-3">
        <label :class="'col-form-label col-sm-' + labelCols" :for="field.id">{{ field.label }}{{
                field.required ? '*' : ''
            }}</label>
        <div :class="'col-sm-' + fieldCols">
            <div v-for="item in fieldData.items" class="form-check form-switch">
                <input :id="item.key"
                       :checked="isChecked(item.key)"
                       :disabled="field.locked"
                       class="form-check-input"
                       type="checkbox"
                       @input="changeSelection(item.key, item.value, $event.target.checked)"> <label :for="item.key"
                                                                                                     class="form-check-label">{{
                    item.value
                }}</label>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        field: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: false,
            defaultValue: ''
        },
        fieldCols: {
            type: String,
            required: true
        },
        labelCols: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            items: []
        }
    },
    computed: {
        fieldData() {
            var parsedFieldData = {
                items: []
            }
            if (this.field.data !== '') {
                parsedFieldData = JSON.parse(this.field.data);
            }

            return parsedFieldData;
        },
        selectedItems() {
            var returnValue = [];
            if (this.value !== '') {
                returnValue = JSON.parse(this.value);
            }

            return returnValue;
        }
    },
    methods: {
        isChecked(key) {
            return this.selectedItems.find(item => item.key === key) !== undefined;
        },
        changeSelection(key, itemValue, value) {
            let returnValue = this.selectedItems.slice();
            if (value) {
                returnValue.push({
                    key: key,
                    value: itemValue
                });
            } else {
                let index = returnValue.findIndex(item => item.key === key);
                returnValue.splice(index, 1);
            }
            this.$emit('update:modelValue', {value: JSON.stringify(returnValue)});
        }
    }
}
</script>